import { render } from "./purchasereport.vue?vue&type=template&id=7d79545c&scoped=true"
import script from "./purchasereport.vue?vue&type=script&lang=js"
export * from "./purchasereport.vue?vue&type=script&lang=js"

import "./purchasereport.vue?vue&type=style&index=0&id=7d79545c&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d79545c"]])

export default __exports__